import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import ContactSection from "../../Components/Contact-us/Contact-section";
import StaticFaqs from "../../Components/Contact-us/FAQs";
import { Helmet } from "react-helmet";

const Contactus =()=>{
    return(
        <>
        <Helmet>
            <title>Contact Us </title>
        </Helmet>
           <div className="container-fluid contactUsbg d-md-block d-none" style={{backgroundImage: 'url(./assests/images/contact-us.svg)'}}>
            <Container>
            <Row>
                <Col md={6}>
                    <h2 className="fs-48">Get In Touch</h2>
                    <p className="w-75 fs-16 fw-normal">
                        Strengthen your brand presence by offering personalized, high-quality merchandise that resonates with your audience and enhances your brand identity.
                    </p>
                </Col>
                <Col md={6} className="ps-5">
                <div className="ps-3 mt-5">
                        <ContactSection/>
                </div>
                  
                
                </Col>
            </Row>

            
            </Container>
            
                

           </div>
           {/**Mobile Section */}
           <div className="contactUsbg d-md-none d-block" >
            <Container >
            <Row className="contactUsbg pt-0 mt-0" >
                <Col md={6} >
                    <h2 className="fs-48">Get In Touch</h2>
                    <p className="w-100 fs-16 fw-normal">
                        Strengthen your brand presence by offering personalized, high-quality merchandise that resonates with your audience and enhances your brand identity.
                    </p>
                </Col>
                <Col md={6} className="p-auto">
                <div className="p-auto mt-3">
                        <ContactSection/>
                </div>
                </Col>
            </Row>
            </Container>
           </div>
           <Container>
           <h2 className="fs-48 w-100 mt-5">Frequently asked <br></br>questions</h2>
            <Row className="align-items-center mb-5">
                <Col md={6}>
                    <StaticFaqs/>
                </Col>
                <Col md={6} className="p-5 d-md-block d-none m-auto" >
                    <img className="img-fluid d-block m-auto" src="./assests/images/faqs.svg" loading="lazy"/>
                </Col>
            </Row>
                </Container>
        </>
    )
}

export default Contactus;